import { productMasterApi } from "./api";

export default async function fetchKamData({ accessToken, mainCountry }) {
  const buildParams = () => {
    const params = new URLSearchParams();
    if (mainCountry?.id) params.append("countryId", mainCountry.id);

    return params;
  };

  const params = buildParams(null, null);
  const res = await productMasterApi.get(`GetKam?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      accept: "*/*",
    },
  });
  return res?.data || [];
}
